
/* injects from baggage-loader */

/*jshint browser: true */
'use strict';

const moduleInsertBlockMenu = angular.module('services.layoutEditor.insertBlockMenu', ['services.editorNamespace', 'services.layoutEditor.blockDragDrop']);

moduleInsertBlockMenu.factory('insertBlockMenu', [
  '$timeout', '$injector', 'ns', 'editorDragPanel', 'Widget', 'Restangular', 'Spacer', 'Section', 'Slider', 'Animation',
  'MapInit', '$rootScope', 'Tutorials', 'Timer', 'FrameForm', 'SubscribeFormManager', '$filter', 'ImageInit', 'ButtonActionsManager',
  ($timeout, $injector, ns, editorDragPanel, Widget, Restangular, Spacer, Section, Slider, Animation,
   MapInit, $rootScope, Tutorials, Timer, FrameForm, SubscribeFormManager, $filter, ImageInit, ButtonActionsManager) => {
    let Y;

    const insertBlockMenu = {
      menu: null,
      point: {},
      ddInstances: [],
      blocksState: [],
      init: function(y) {
        Y = y;
        this.menu = Y.one('.et-block-list_window');
        this.initDD();
      },
      destroy: function() {
        this.destroyDD();
      },
      initDD: function() {
        const parent = this;
        const blocksMenu = Y.all(ns.menuBlockClass);

        blocksMenu.each(function(v) {
          const dd = new Y.DD.Drag({
            node: v,
            target: {
              padding: '0 0 0 20'
            }
          }).plug(Y.Plugin.DDProxy, {
            moveOnEnd: false
          }).plug(Y.Plugin.DDWinScroll);

          parent.setEvents(dd, Y, v);
          parent.ddInstances.push(dd);
          parent.blocksState.push({
            id: v._yuid,
            lock: false
          });
        });
      },
      lockWidgets: function() {
        if (this.ddInstances) {
          this.ddInstances.forEach(function(v) {
            v.set('lock', true);
          });
        }

        if (this.blocksState.length > 0) {
          this.blocksState.forEach(function(state) {
            state.lock = true;
          });
        }
      },
      unlockWidgets: function() {
        if (this.ddInstances) {
          this.ddInstances.forEach(function(v) {
            v.set('lock', false);
          });
        }

        if (this.blocksState.length > 0) {
          this.blocksState.forEach(function(state) {
            state.lock = false;
          });
        }
      },
      widgetIsLock: function(block) {
        let isLock = false;

        if (this.blocksState.length > 0) {
          this.blocksState.every(function(state) {
            if (block._yuid === state.id) {
              isLock = state.lock;
              return false;
            } else {
              return true;
            }
          });
        }

        return isLock;
      },
      destroyDD: function() {
        const blocksMenu = Y.all(ns.menuBlockClass);

        blocksMenu.each(function(v) {
          const id = v.get('id');
          const dd = Y.DD.DDM.getDrag('#' + id);

          if (dd) {
            dd.destroy();
          }

          if (dd) {
            dd._unprep();
          }
        });
      },
      show: function(point) {
        if ($(this.menu._node).scope().widgetMenuShow) {
          return false;
        }

        Y.one(window).on('click', this.customBlur);
        Y.one(window).on('scroll', this._onScroll, this);

        this.point = point;
        $(this.menu._node).scope().widgetMenuShow = true;

        if (!$(this.menu._node).scope().$$phase) {
          $(this.menu._node).scope().$apply();
        }

        return this.position(point, this.menu);
      },
      hide: function() {
        Y.one(window).detach('click', this.customBlur);
        Y.one(window).detach('scroll', this._onScroll, this);
        this.hideMenu();
      },
      isOpen: function() {
        return this.menu.hasClass(ns.blockMenuClassShow);
      },
      _onScroll: function() {
        if (this.isOpen()) {
          this.hide();
        }
      },
      updateWidgetsOnResize: function() {
        Slider.updateSliders();
        FrameForm.updateFrameForms(this.targetNode);
      },
      isBlockType: function(block, type) {
        if (block) {
          return block.hasClass('str-bw_' + type);
        }
      },
      customBlur: function(e) {
        const target = e.target;
        const notIP = !target.hasClass(ns.insertPointClass);
        const notBlockMenu = !target.ancestor(ns.blockMenuClass);

        if (notIP && notBlockMenu) {
          insertBlockMenu.hide();
        }
      },
      setEvents: function(dd, Y, blockMenu) {
        const blockDragDrop = $injector.get('blockDragDrop');
        const layoutEditor = $injector.get('layoutEditor');

        dd.before('drag:start', blockDragDrop._beforeDragStart);
        dd.on('drag:start', this._onDragStart, blockDragDrop);
        dd.on('drag:over', blockDragDrop._onDragOver, blockDragDrop);
        dd.on('drag:end', blockDragDrop._onDragEnd, blockDragDrop);
        dd.after('drag:end', this._afterDragEnd, this);

        if (layoutEditor.isTouchEnabled()) {
          blockMenu.detach('click', blockDragDrop._onClick, blockDragDrop);
          blockMenu.on('click', blockDragDrop._onClick, blockDragDrop);
        } else {
          blockMenu.detach('click', Tutorials._sectionDropTutorial, Tutorials);
          blockMenu.on('click', Tutorials._sectionDropTutorial, Tutorials);
        }
      },
      _afterDragEnd: function() {},
      _onDragStart: function(e) {
        this.widgetsPreCapture();
        this._onDragStart(e, true);
      },
      getWidgetType: function(block) {
        return $(block._node).scope().block.type;
      },
      newGuid: function() {
        const s4 = function() {
          return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
        };
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
      },
      addAttributes: function(node, widget, target, type) {
        node.setAttribute('data-block-id', widget.id);
        node.one(ns.widgetWrapperClass).addClass('str-bw_' + widget.id);
        node.widget = Restangular.stripRestangular(widget);

        if (target && target.float) {
          node.widget.float = target.float;
          node.widget.float_size = 6;
        } else {
          delete node.widget.float;
          delete node.widget.float_size;
        }

        if (target) {
          target.float = undefined;
        }
      },
      hideMenu: function() {
        $(this.menu._node).scope().widgetMenuShow = false;
        if (!$(this.menu._node).scope().$$phase) {
          $(this.menu._node).scope().$apply();
        }
      },
      afterCreateWidget: function(node, widget, target, type, showSettings) {
        if (showSettings === null || showSettings === undefined) {
          showSettings = true;
        }

        $(node._node).slideUp(0);

        const blockOverlays = $injector.get('blockOverlays');
        const ContentEditable = $injector.get('ContentEditable');
        const insertBlockMenu = $injector.get('insertBlockMenu');

        this.addAttributes(node, widget, target, type);

        editorDragPanel.addPanelsBlock(node);
        const contentHtml = widget.html;

        if (type !== 'text') {
          node.one(ns.widgetWrapperClass).setContent(contentHtml);
          ContentEditable.bind(node, true);
        }

        if (type === 'code') {
          const codeHTML = (
            '<div class="str-bw_code-html-overlay">' +
              '<img class="str-bw_code-html-overlay-icon" src="/constructor/editor/assets/images/code-overlay-icon.svg" />' +
              '<div class="str-bw_code-html-overlay-text">' + ($filter('translate')('widget.code.text')) + '</div>' +
            '</div>'
          );
          node.one('.str-bw_code-html').setContent(codeHTML);
        }

        if (type === 'facebook_comment') {
          const fbHTML = (
            '<div class="str-bw_code-html-overlay str-bw_code-html-overlay_fb">' +
              '<img class="str-bw_code-html-overlay-icon" src="/constructor/editor/assets/images/code-overlay-icon.svg" />' +
              '<div class="str-bw_code-html-overlay-text">' + ($filter('translate')('widget.comments.text')) + '</div>' +
            '</div>'
          );
          node.one('.strw-fb-comments').setContent(fbHTML);
        }

        this._onCreatingEnd(node, contentHtml);
        $timeout(function() {
          $(node._node).slideDown(200, function() {
            const blockDragDrop = $injector.get('blockDragDrop');
            blockDragDrop._afterDragEnd();
          });
        });
        $timeout(function() {
          insertBlockMenu.unlockWidgets();
        }, 1000);
        $timeout(function() {
          blockOverlays.addOverlaysToBlocks();
        }, 300);
      },
      createWidgetError: function(node, target, type) {
        const blockDragDrop = $injector.get('blockDragDrop');
        node.remove();
        this._onCreatingEnd(node, '');
        blockDragDrop.clean();
      },
      setBlankContentHtml: function(type, node, target) {
        const self = this;
        const section = target.ancestor(ns.sectionClass).section;
        const insertBlockMenu = $injector.get('insertBlockMenu');

        Widget.create(section.id, type, section.is_template).then(function(widget) {
          self.afterCreateWidget(node, widget, target, type);
        }, function() {
          insertBlockMenu.unlockWidgets();
          self.createWidgetError(node, target, type);
        });
      },
      widgetInitializer: function(node, contentHtml) {
        if (this.isBlockType(node, 'text')) {
          this.initAsTextBlock(node, contentHtml);
        }
        if (this.isBlockType(node, 'headline_h1')) {
          this.initAsTextBlock(node, contentHtml);
        }
        if (this.isBlockType(node, 'headline_h2')) {
          this.initAsTextBlock(node, contentHtml);
        }
        if (this.isBlockType(node, 'headline_h3')) {
          this.initAsTextBlock(node, contentHtml);
        }
        if (this.isBlockType(node, 'map')) {
          MapInit.initMap(0, $(node._node).find('.strw__map'));
        }

        const sliderWidget = node.one('.' + ns.sliderClass);

        if (sliderWidget) {
          Slider.initSlider(0, sliderWidget._node);
        }
        if (this.isBlockType(node, 'timer')) {
          const timerWidget = node.one('.strbw-timer');
          Timer.initTimer(0, timerWidget._node);
        }
        if (this.isBlockType(node, 'subscribe_form')) {
          SubscribeFormManager.updateOptions(node.widget);
        }
        if (this.isBlockType(node, 'image')) {
          ImageInit.updateOptions(node.widget);
        }
        if (this.isBlockType(node, 'link')) {
          ButtonActionsManager.updateOptions(node.widget);
        }
        if (this.isBlockType(node, 'button')) {
          ButtonActionsManager.updateOptions(node.widget);
        }
        if (this.isBlockType(node, 'card')) {
          ButtonActionsManager.updateOptions(node.widget);
        }
        if (this.isBlockType(node, 'product')) {
          node.widget.product_items_attributes.map(function(widget, id) {
            if (widget.item_type === 'button') {
              ButtonActionsManager.updateOptions(node.widget.product_items_attributes[id]);
            }
          });
        }
      },
      _onCreatingEnd: function(node, contentHtml) {
        const self = this;

        node.one(ns.widgetWrapperClass).setStyles(node.widget.style_attributes);
        Y.one(document).detach('click', this.customBlur);
        Y.one(window).detach('scroll', this._onScroll, this);

        $timeout(function() {
          self.widgetInitializer(node, contentHtml);
        }, 150);
      },
      initAsTextBlock: function(block, contentHtml) {
        const Text = $injector.get('Text');
        const blockinner = block.one(ns.widgetWrapperClass);

        Text.editBlockInit(blockinner);
        Text.setData(block, contentHtml);

        if (CKEDITOR.instances[blockinner._yuid]) {
          CKEDITOR.instances[blockinner._yuid].on('change', Text._onChangeText, Text);
        } else {
          console.error('CKEDITOR instance ' + blockinner._yuid + ': Not found!');
        }
      },
      createAndInitBlock: function(block, target, manual) {
        if (manual === null || manual === undefined) {
          manual = false;
        }

        const layoutEditor = $injector.get('layoutEditor');
        const blocksBuilder = $injector.get('blocksBuilder');

        let type;
        if (!manual) {
          type = this.getWidgetType(block);
        } else {
          type = manual;
        }

        const node = blocksBuilder.createBlock(ns.blockLoader, type);

        if ($(block._node).scope() && $(block._node).scope().block) {
          node.widget = {
            min_size: $(block._node).scope().block.min_size
          };
        }

        layoutEditor.setHandleBlocks(node);
        this.setBlankContentHtml(type, node, target);

        return node;
      },
      position: function(point, element) {
        let elPosX = point.getXY()[0] + 14;
        let elPosY = point.getXY()[1];

        const bottom = $(window).scrollTop() + $(window).height();
        const right = $(window).scrollLeft() + $(window).width();
        const height = $(element._node).height();
        const width = $(element._node).width();
        const overBottom = elPosY + height > bottom;
        const overRight = elPosX + width > right;
        const overTop = elPosY - height - $(window).scrollTop() < 0;
        const overLeft = elPosX - width < 0;

        if (overBottom) {
          elPosY -= height + 5;
          elPosX -= width / 2 - 10;
        } else if (overTop) {
          elPosX += 27;
          elPosY += 30;
        }

        if (overRight) {
          elPosX -= width + 10;
        }

        if (overTop && overRight) {
          elPosX += width / 2 + 50;
        }

        if (overBottom && overRight) {
          elPosX += width / 2 + 50;
        }

        if (overLeft) {
          elPosY += 30;
        }

        if (overLeft && overBottom) {
          elPosX += width / 2 + 17;
        }

        if (overTop && overLeft) {
          elPosY -= 60;
          elPosX += 0;
        }

        if (!overBottom && !overTop && !overRight && !overLeft) {
          elPosX += 25;
          elPosY -= height / 2 - 10;
        }

        return element.setXY([elPosX, elPosY]);
      }
    };
    return insertBlockMenu;
  }
]);




// WEBPACK FOOTER //
// ./src/app/editor/services/layout_editor/insertBlockMenu.js